// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.titoletto-small,
ion-item p.titoletto-small {
  font-size: 0.8rem;
  white-space: normal;
}

.sottotitoletto-small,
ion-item p.sottotitoletto-small {
  font-size: 0.7rem;
  margin-top: -4px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/recupero-editor/recupero-editor.component.scss"],"names":[],"mappings":"AACA;;EAEI,iBAAA;EACA,mBAAA;AAAJ;;AAGA;;EAEI,iBAAA;EACA,gBAAA;AAAJ","sourcesContent":["\n.titoletto-small,\n    ion-item p.titoletto-small {\n    font-size: 0.8rem;\n    white-space: normal;\n}\n\n.sottotitoletto-small,\n    ion-item p.sottotitoletto-small {\n    font-size: 0.7rem;\n    margin-top: -4px;\n}\n    \n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
